import cx from 'classnames';
import styles from './MoneyContainer.module.scss';

import { FC } from 'react';
import { Typography } from '../Typography';
import {
  getTicketClassName,
  getTicketIconSrc,
} from '@features/LotteryGame/helpers/ticketNumberUtils';
import { SuperTicketType } from '@features/LotteryGame/types';

interface MoneyContainerProps {
  prize: number | string;
  className?: string;
  variant: 'light' | 'dark';
  luckyTicketNumber?: string;
}

export const MoneyContainer: FC<MoneyContainerProps> = ({
  prize,
  variant,
  className,
  luckyTicketNumber,
}) => {
  const ticketStyleClass = getTicketClassName(luckyTicketNumber as SuperTicketType);
  return (
    <div className={cx(styles.mcContainer, styles[variant], className)}>
      <img
        width={22}
        height={22}
        alt="dollar"
        src={getTicketIconSrc(luckyTicketNumber as SuperTicketType)}
        className={styles.mcIcon}
      />

      <Typography
        component="h3"
        variant={'primary'}
        className={cx(styles.mcNum, styles[ticketStyleClass!])}
      >
        {prize}
      </Typography>
    </div>
  );
};
